module.exports = __webpack_public_path__ + "images/historical/Removed_from_list.png";